import type { TSystem } from "@aspen/model";
import { BRAND } from "@aspen/model";

export const systemDetection: () => TSystem = () => {
  // 默认系统 Aspen Digital
  // NEXT_PUBLIC_BRAND 的值是string | undefined, systemDetection需要返回的类型是TSystem
  return (process.env.NEXT_PUBLIC_BRAND || BRAND) as TSystem;
};
